import { connect } from 'react-redux'
import { get } from 'lodash'

import { HostedVoiceServicesListComponent } from './HostedVoiceServicesList'
import { listServices } from 'features/Services/HostedVoice/HostedVoice.actions'
import { reduxForm } from 'redux-form'
import { showMobileServiceFormModal } from 'features/MobileServices/MobileServiceFormModal'

const formName = 'hostedVoiceServicesListFilter'

const stateToProps = ({ services: { hostedVoice }, form }) => {
  const filterOptions = {
    serviceType: [{ name: 'Any', value: '' }],
    status: [{ name: 'Any', value: '' }],
    ban: [{ name: 'Any', value: '' }],

    hasMultipleBans: function() {
      return this.ban.length > 2
    },
  }

  // get unique service types for filter
  hostedVoice.services
    .reduce(
      (uniqueTypes, service) =>
        uniqueTypes.includes(service.serviceType)
          ? uniqueTypes
          : uniqueTypes.push(service.serviceType) && uniqueTypes,
      []
    )
    .map(type => filterOptions.serviceType.push({ name: type, value: type }))

  // get unique statuses for filter
  hostedVoice.services
    .reduce(
      (uniqueStatuses, service) =>
        uniqueStatuses.includes(service.billingStatus || '–')
          ? uniqueStatuses
          : uniqueStatuses.push(service.billingStatus || '–') && uniqueStatuses,
      []
    )
    .map(status => filterOptions.status.push({ name: status, value: status }))

  // get unique BANs for filter
  hostedVoice.services
    .reduce(
      (uniqueBANs, service) =>
        uniqueBANs.includes(service.ban) ? uniqueBANs : uniqueBANs.push(service.ban) && uniqueBANs,
      []
    )
    .map(ban => filterOptions.ban.push({ name: ban, value: ban }))

  // filter services
  const filter = get(form, [formName, 'values'], {})

  const matcher = !!filter.search
    ? new RegExp(filter.search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i')
    : new RegExp('')

  const services = hostedVoice.services.filter(service => {
    const serviceTypeMatch = !filter.serviceType || service.serviceType === filter.serviceType
    const statusMatch = !filter.status || (service.billingStatus || '–') === filter.status
    const banMatch = !filter.ban || service.ban === filter.ban

    const searchTextMatch =
      !filter.search ||
      (!!service.number && service.number.includes(filter.search)) ||
      (!!service.id && service.id.includes(filter.search)) ||
      (!!service.customerReference && matcher.test(service.customerReference))

    return statusMatch && serviceTypeMatch && banMatch && searchTextMatch
  })

  return {
    loading: hostedVoice.servicesLoading,
    services,
    filterOptions,
  }
}

const dispatchToProps = {
  listServices,
  showMobileServiceFormModal,
}

export const HostedVoiceServicesList = connect(
  stateToProps,
  dispatchToProps
)(reduxForm({ form: formName })(HostedVoiceServicesListComponent))



// WEBPACK FOOTER //
// src/features/Services/HostedVoice/HostedVoiceServicesList/HostedVoiceServicesList.container.ts